import { formatDateHuman, parseDateRaw } from "../date-utils";
export const qualityWasteFields = [{
        name: "documentDate",
        title: "Data",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatDateHuman(parseDateRaw(record.documentDate))
        /*
        },{
          name: "year",
          title: "Anno",
          titleClass: "has-text-centered",
          dataClass: "has-text-centered",
          render: (record: IQualityWaste) => record.year
        }, {
          name: "month",
          title: "Mese",
          titleClass: "has-text-centered",
          dataClass: "has-text-centered",
          render: (record: IQualityWaste) => record.month
        */
    }, {
        name: "description",
        title: "Descrizione",
        render: (record) => record.description
    }, {
        name: "cat3Kg",
        title: "KG Cat.3",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => record.cat3Kg
    }, {
        name: "cat2Kg",
        title: "KG Cat.2",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => record.cat2Kg
    }];
